export default "__VITE_ASSET__iQBR$x$r__"